import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CheckboxComponent } from './shared/checkbox/checkbox.component';
import {LoadingComponent} from './shared/loading/loading.component';
import { ProductService } from './services/ProductService';
import { FacadeService } from './services/FacadeService';

import {ArrayFilterPipe} from './pipes/ArrayFilterPipe';

//Mat Library
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { ProjectDialogComponent } from './components/project-dialog/project-dialog.component';
import { LoginDialogComponent } from './components/login-dialog/login-dialog.component';
import { RegistrationDialogComponent } from './components/registration-dialog/registration-dialog.component';
import { ButtonComponent } from './shared/button/button.component';

import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './store';
import { ResetPasswordDialogComponent } from './components/reset-password-dialog/reset-password-dialog.component';
import { ProjectSearchDialogComponent } from './components/project-search-dialog/project-search-dialog.component';
import {DataTablesModule} from 'angular-datatables';
import {HttpRequestInterceptor} from './services/HttpRequestInterceptor';
import { AuthInterceptor } from './services/AuthInterceptor';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';

import { APP_INITIALIZER, inject } from '@angular/core';
import { ConfigService } from './services/config.service';
import { initializeApp } from './app-initializer';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CheckboxComponent,
    LoadingComponent,
    ArrayFilterPipe,
    ProjectDialogComponent,
    LoginDialogComponent,
    RegistrationDialogComponent,
    ButtonComponent,
    ResetPasswordDialogComponent,
    ProjectSearchDialogComponent,
    ConfirmationDialogComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    NgSelectModule, 
    FormsModule, 
    BrowserAnimationsModule,
    MatInputModule,
    MatDialogModule,
    StoreModule.forRoot(reducers, {metaReducers}),
    DataTablesModule
  ],
  providers: [
    ProductService,
    FacadeService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true
    }
    /*{provide: HTTP_INTERCEPTORS, useClass:AuthInterceptor, multi:true }*/
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
